/* tslint:disable */
/* eslint-disable */
/**
 * API
 * API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { AnnouncementCreationRequestDto } from '../models';
// @ts-ignore
import type { AnnouncementsFeedDto } from '../models';
// @ts-ignore
import type { ChatMessageCreationResponseDto } from '../models';
// @ts-ignore
import type { ChatReadStatusUpdateRequestDto } from '../models';
/**
 * RestAnnouncementsApi - axios parameter creator
 */
export const RestAnnouncementsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Mark announcements as read up to the given time
         * @param {ChatReadStatusUpdateRequestDto} chatReadStatusUpdateRequestDto Read announcements up to this time
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        markAnnouncementsRead: async (chatReadStatusUpdateRequestDto: ChatReadStatusUpdateRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'chatReadStatusUpdateRequestDto' is not null or undefined
            assertParamExists('markAnnouncementsRead', 'chatReadStatusUpdateRequestDto', chatReadStatusUpdateRequestDto)
            const localVarPath = `/api/announcements/mark-as-read`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(chatReadStatusUpdateRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Post an announcement to every active user
         * @param {AnnouncementCreationRequestDto} announcementCreationRequestDto Announcement to post
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postAnnouncement: async (announcementCreationRequestDto: AnnouncementCreationRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'announcementCreationRequestDto' is not null or undefined
            assertParamExists('postAnnouncement', 'announcementCreationRequestDto', announcementCreationRequestDto)
            const localVarPath = `/api/announcements`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(announcementCreationRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Read the latest announcements addressed to every active user
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        readAnnouncements: async (limit?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/announcements`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RestAnnouncementsApi - functional programming interface
 */
export const RestAnnouncementsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RestAnnouncementsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Mark announcements as read up to the given time
         * @param {ChatReadStatusUpdateRequestDto} chatReadStatusUpdateRequestDto Read announcements up to this time
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async markAnnouncementsRead(chatReadStatusUpdateRequestDto: ChatReadStatusUpdateRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.markAnnouncementsRead(chatReadStatusUpdateRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestAnnouncementsApi.markAnnouncementsRead']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Post an announcement to every active user
         * @param {AnnouncementCreationRequestDto} announcementCreationRequestDto Announcement to post
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postAnnouncement(announcementCreationRequestDto: AnnouncementCreationRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ChatMessageCreationResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postAnnouncement(announcementCreationRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestAnnouncementsApi.postAnnouncement']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Read the latest announcements addressed to every active user
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async readAnnouncements(limit?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AnnouncementsFeedDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.readAnnouncements(limit, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestAnnouncementsApi.readAnnouncements']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * RestAnnouncementsApi - factory interface
 */
export const RestAnnouncementsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RestAnnouncementsApiFp(configuration)
    return {
        /**
         * 
         * @summary Mark announcements as read up to the given time
         * @param {ChatReadStatusUpdateRequestDto} chatReadStatusUpdateRequestDto Read announcements up to this time
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        markAnnouncementsRead(chatReadStatusUpdateRequestDto: ChatReadStatusUpdateRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.markAnnouncementsRead(chatReadStatusUpdateRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Post an announcement to every active user
         * @param {AnnouncementCreationRequestDto} announcementCreationRequestDto Announcement to post
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postAnnouncement(announcementCreationRequestDto: AnnouncementCreationRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<ChatMessageCreationResponseDto> {
            return localVarFp.postAnnouncement(announcementCreationRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Read the latest announcements addressed to every active user
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        readAnnouncements(limit?: number, options?: RawAxiosRequestConfig): AxiosPromise<AnnouncementsFeedDto> {
            return localVarFp.readAnnouncements(limit, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * RestAnnouncementsApi - interface
 */
export interface RestAnnouncementsApiInterface {
    /**
     * 
     * @summary Mark announcements as read up to the given time
     * @param {ChatReadStatusUpdateRequestDto} chatReadStatusUpdateRequestDto Read announcements up to this time
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    markAnnouncementsRead(chatReadStatusUpdateRequestDto: ChatReadStatusUpdateRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @summary Post an announcement to every active user
     * @param {AnnouncementCreationRequestDto} announcementCreationRequestDto Announcement to post
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postAnnouncement(announcementCreationRequestDto: AnnouncementCreationRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<ChatMessageCreationResponseDto>;

    /**
     * 
     * @summary Read the latest announcements addressed to every active user
     * @param {number} [limit] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    readAnnouncements(limit?: number, options?: RawAxiosRequestConfig): AxiosPromise<AnnouncementsFeedDto>;

}

/**
 * RestAnnouncementsApi - object-oriented interface
 */
export class RestAnnouncementsApi extends BaseAPI implements RestAnnouncementsApiInterface {
    /**
     * 
     * @summary Mark announcements as read up to the given time
     * @param {ChatReadStatusUpdateRequestDto} chatReadStatusUpdateRequestDto Read announcements up to this time
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public markAnnouncementsRead(chatReadStatusUpdateRequestDto: ChatReadStatusUpdateRequestDto, options?: RawAxiosRequestConfig) {
        return RestAnnouncementsApiFp(this.configuration).markAnnouncementsRead(chatReadStatusUpdateRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Post an announcement to every active user
     * @param {AnnouncementCreationRequestDto} announcementCreationRequestDto Announcement to post
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public postAnnouncement(announcementCreationRequestDto: AnnouncementCreationRequestDto, options?: RawAxiosRequestConfig) {
        return RestAnnouncementsApiFp(this.configuration).postAnnouncement(announcementCreationRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Read the latest announcements addressed to every active user
     * @param {number} [limit] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public readAnnouncements(limit?: number, options?: RawAxiosRequestConfig) {
        return RestAnnouncementsApiFp(this.configuration).readAnnouncements(limit, options).then((request) => request(this.axios, this.basePath));
    }
}

